export const companies = {
  Wellevate: "Wellevate by Fullscript",
  EmersonEcologics: "Emerson Ecologics by Fullscript",
} as const;
